var $ = require('../internals/export');
var assign = require('../internals/object-assign');

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.object.assign.js
// module id = 1272
// module chunks = 1